import mixinSnackbarMessage from '@/mixins/snackbar-message'
import TransactionStatus from '@/models/enums/TransactionStatus'

export default {
  mixins: [mixinSnackbarMessage],
  methods: {
    cancelTransaction () {
      this.isCancelLoading = true
      const id = this.transaction.id
      this.$store.dispatch('transactions/cancelTransaction', id)
        .then(res => {
          if (res.status !== 200) {
            this.showErrorMessage(res.response.data.message)
          }
        }).finally(() => {
        this.computedShow = false
        this.isCancelLoading = false
        clearInterval(this.reqInterval)
      })
    },
    updateTransaction () {
      this.isLoading = true

      const id = this.transaction.id

      const data = {
        courierId: this.transaction.sender.id,
        operationType: this.currentCurrency,
        paymentType: this.currentCurrency,
        price: this.amount,
      }

      if (this.currentCurrency === 'terminal' && this.checks) {
        data.quantityChecks = this.checks
      }

      this.$store.dispatch('transactions/waitTransaction', { id, data })
        .then(res => {
          if (res.status !== 200) {
            this.showErrorMessage(res.response.data.message)
          }
        })

      this.isLoading = true
      this.isCurrencyDisabled = true
      clearInterval(this.reqInterval)

      this.reqInterval = setInterval(() => {
        this.$store.dispatch('transactions/fetchSingleTransaction', id).then(res => {
          const data = res.data.data
          // this.transactionResults = data
          if (data.status === TransactionStatus.Completed ||
                data.status === TransactionStatus.Cancel) {
            clearInterval(this.reqInterval)
            this.isLoading = false
            this.showCompletedWindow = true
            this.transactionStatus = data.status
            this.transactionResults = data
            if (this.$root.$refs.cashierGetBalance) {
              this.$root.$refs.cashierGetBalance()
            }
          }
        })
      }, 3000)
    },
  },
}
